<template>
  <div class="row py-2">
    <div class="col-lg-6 offset-lg-3 col-12">
      <h2>Choose Service</h2>
      <section>
        <h3>บริการล้างแอร์</h3>
        <div class="grid-container">

          <a href="https://www.q-chang.com/p/ac-cleaning-wall-type?sku=84c8e767-5bdc-3794-ac89-a7489afff95b&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized01_2023_01_25.png" alt=""
                    class="card-img-top">
              <div class="card-body px-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างแอร์ผนัง</b>
                </div>
              </div>
            </div>
          </a>

          <a href="https://www.q-chang.com/p/ac-cleaning-celling-type?sku=c591e606-400f-3d67-8ea2-f47877731150&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized02_2023_01_30.jpg" alt=""
                    class="card-img-top">
              <div class="card-body px-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างแอร์แขวน/ตั้งพื้น</b>
                </div>
              </div>
            </div>
          </a>

          <a href="https://www.q-chang.com/p/ac-cleaning-4-ways-cassette-type?sku=9a1da77a-2b27-3404-8277-7d2970cfcbd6&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized03_2023_01_30.jpg" alt=""
                    class="card-img-top">
              <div class="card-body px-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างแอร์ 4 ทิศทาง</b>
                </div>
              </div>
            </div>
          </a>

        </div>
      </section>

      <section class="mt-5 mb-2">
        <h3>บริการล้างเครื่องซักผ้า</h3>
        <div class="grid-container">

          <a href="https://www.q-chang.com/p/washer-cleaning-toploader?sku=3883039f-1014-3df1-bb20-76125152ab49&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized01_2023_01_25.png" alt=""
                   class="card-img-top">
              <div class="card-body px-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างเครื่องซักผ้า (ฝาบน)</b>
                </div>
              </div>
            </div>
          </a>

          <a href="https://www.q-chang.com/p/washer-cleaning-frontloader?sku=d0d04c3f-4f67-31ed-9ba8-e8a0c5029631&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized02_2023_01_25.png" alt=""
                   class="card-img-top">
              <div class="card-body px-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างเครื่องซักผ้า (ฝาหน้า)</b>
                </div>
              </div>
            </div>
          </a>

          <a href="https://www.q-chang.com/p/washer-and-dryer-cleaning?sku=78eee1db-3139-3ece-94c1-95d1abab62b3&isPublished=false&channel=BeNeat">
            <div class="card my-1 h-100">
              <img src="https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized03_2023_01_25.png" alt=""
                   class="card-img-top">
              <div class="card-body px-lg-2 py-3 d-flex justify-content-center align-items-center">
                <div class="text-center text-dark">
                  <b>บริการล้างเครื่องซักอบผ้า (ฝาหน้า)</b>
                </div>
              </div>
            </div>
          </a>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  computed: {
    isBetweenPromotionDays () {
      const dateNow = moment(new Date())
      const startDate = moment('22/02/2023 00:00:00', 'DD/MM/YYYY HH:mm:ss')
      const endDate = moment('28/02/2023 23:59:59', 'DD/MM/YYYY HH:mm:ss')
      return dateNow.isBetween(startDate, endDate)
    }
  }
}
</script>

<style scoped>
  .grid-container {
    display: grid;
    row-gap: 10px;
    column-gap: 10px;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
  }

  @media (min-width:768px) {
    .service-title {
      font-size: 14px;
    }
  }
  @media (min-width:1024px) {
    .service-title {
      font-size: 15px;
    }
  }
  @media (min-width:1280px) {
    .service-title {
      font-size: 16px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/qChang/Step2.vue